/* eslint-disable i18next/no-literal-string */
import React, { useEffect, useRef } from 'react';
import hey1 from 'assets/images/gen-ai-image-landing/hey/1.png';
import hey2 from 'assets/images/gen-ai-image-landing/hey/2.png';
import hey3 from 'assets/images/gen-ai-image-landing/hey/3.png';
import hey4 from 'assets/images/gen-ai-image-landing/hey/4.png';
import hey5 from 'assets/images/gen-ai-image-landing/hey/5.png';
import hey6 from 'assets/images/gen-ai-image-landing/hey/6.png';
import hey7 from 'assets/images/gen-ai-image-landing/hey/7.png';
import hey8 from 'assets/images/gen-ai-image-landing/hey/8.png';
import styles from './Hey.module.scss';

export default function Hey() {
  const sectionRef = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current || !textRef.current) return;

      const section = sectionRef.current;
      const text = textRef.current;
      const rect = section.getBoundingClientRect();
      const sectionHeight = section.offsetHeight;
      const viewportHeight = window.innerHeight;

      // Calculate scroll progress through the section
      let progress = 0;

      if (rect.bottom > 0 && rect.top < viewportHeight) {
        // Section is visible in viewport
        if (rect.top <= 0 && rect.bottom >= viewportHeight) {
          // Section is fully in view or extends beyond viewport
          const scrolledIntoSection = Math.abs(rect.top);
          progress = Math.min(scrolledIntoSection / (sectionHeight - viewportHeight), 1);
        } else if (rect.top > 0) {
          // Section is entering from bottom - start transition when more visible
          const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
          progress = Math.max(0, (visibleHeight / viewportHeight) * 0.02); // Very small progress when entering
        } else if (rect.bottom < viewportHeight) {
          // Section is leaving view
          progress = 1;
        }
      } else {
        // Section is not visible
        progress = rect.top > 0 ? 0 : 1;
      }

      // Apply blur based on progress (blur at start and end)
      let blurAmount = 0;
      let opacity = 1;

      if (progress < 0.015) {
        // Entering section - blur to focus (short transition)
        blurAmount = (0.015 - progress) * 667; // 0-10px blur
        opacity = 0.3 + (progress * 47); // 0.3-1 opacity
      } else if (progress > 0.85) {
        // Leaving section - focus to blur (longer transition)
        blurAmount = (progress - 0.85) * 66.67; // 0-10px blur
        opacity = 1 - ((progress - 0.85) * 4.67); // 1-0.3 opacity
      } else {
        // In middle of section - clear (longer clear period)
        blurAmount = 0;
        opacity = 1;
      }

      text.style.filter = `blur(${blurAmount}px)`;
      text.style.opacity = opacity;
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial call

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.heySection} ref={sectionRef}>
      {/* Sticky text content - spans all 3 screen heights */}
      <div className={styles.stickyContent} ref={textRef}>
        <div className={styles.heyText}>
          Hey
        </div>
        <div className={styles.heyText}>
          I would like to design a living room
        </div>
        <div className={styles.heyText}>
          in Scandinavian style
        </div>
      </div>

      {/* Second screen height: with positioned images */}
      <div className={styles.screenHeight}>
        <img src={hey1} alt="Interior 1" className={styles.image1} />
        <img src={hey2} alt="Interior 2" className={styles.image2} />
        <img src={hey3} alt="Interior 3" className={styles.image3} />
        <img src={hey4} alt="Interior 4" className={styles.image4} />
      </div>

      {/* Third screen height: with positioned images */}
      <div className={styles.screenHeight}>
        <img src={hey5} alt="Interior 5" className={styles.image5} />
        <img src={hey6} alt="Interior 6" className={styles.image6} />
        <img src={hey7} alt="Interior 7" className={styles.image7} />
        <img src={hey8} alt="Interior 8" className={styles.image8} />
      </div>
    </div>
  );
}
